import Layout from "@/layout";

export default {
  path: "/contacts",
  component: Layout,
  redirect: "/contacts/index",
  children: [
    {
      path: "index",
      name: "contacts",
      component: () =>
        import(/* webpackChunkName: "contacts-list" */ "@/views/contacts"),
      meta: {
        title: "Contacts",
        icon: "contacts-v2",
        keepName: "contactsIndex",
        keepAlive: true,
      },
    },
    {
      path: "contactsAdd",
      name: "contactsAdd",
      component: () =>
        import(/* webpackChunkName: "contacts-add" */ "@/views/contacts/add"),
      meta: { activeMenu: "/contacts/index" },
      hidden: true,
    },
    {
      path: "contactsDetails",
      name: "contactsDetails",
      component: () =>
        import(
          /* webpackChunkName: "contacts-details" */ "@/views/contacts/details"
        ),
      meta: { activeMenu: "/contacts/index" },
      hidden: true,
    },
  ],
};
